/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/30
 */
import './index.css';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import Pagination from 'rc-pagination';
import Prev from '../../../svgs/prev';
import Next from '../../../svgs/next';
import Dots from '../../../svgs/dots';
import Link from './link';

class Page extends Component {
  render () {
    const location = this.props.location;
    const itemRender = function (page, type) {
      // 上一页
      if (type === 'prev') {
        if (this.current === 1) {
          return <Link><Prev /></Link>
        }
        return <Link location={location} query={{ current: this.current - 1 }}>
          <Prev />
        </Link>
      }
      // 下一页
      if (type === 'next') {
        if (this.total === 0
          ||this.current === Math.ceil(this.total / this.pageSize)) {
          return <Link><Next /></Link>
        }
        return <Link location={location} query={{ current: this.current + 1 }}>
          <Next />
        </Link>
      }
      // 不提供跳页面功能
      if (type === 'jump-prev' || type === 'jump-next') {
        return <Dots />;
      }

      return <Link location={location} query={{ current: page }}>{page}</Link>
    };
    return <Pagination prefixCls="store-pagination"
                       {...this.props}
                       itemRender={itemRender}/>;
  }
}

export default connect(
  state => ({
    location: state.router.location
  })
)(Page);



// WEBPACK FOOTER //
// ./src/components/lib/pagination/index.js